<template>
  <ion-slides  v-if="banners.length && position != 'fullscreen'" pager="false"
               :options="{'loop': banners.length > 1 ? 'true' : 'false', 'autoplay': banners.length > 1 ? {'delay': 5000} : 'false','direction':direction}"
               class="banner-wrapper"
               :style="{'border-bottom': position == 'top' ? '1px solid lightgrey' : 'none', 'border-top': position == 'bottom' ? '1px solid lightgrey' : 'none'}">
    <ion-slide class="swiper-no-swiping" v-for="banner in banners" :key="banner.id">
      <a :href="banner.target_link" style="height:100%" @click="trackBanner(banner.name)">
        <img :src="banner.file">
      </a>

    </ion-slide>
  </ion-slides>
  <div id="fullbanner" v-if="banners.length > 0 && position == 'fullscreen' && show && isDashboard"
       @click="openLink(banners[0])" :style="getStyle(banners[0])"
       style=""></div>

</template>
<script>
import {IonSlides, IonSlide} from '@ionic/vue';
import {defineComponent} from 'vue';
import {mapActions} from "vuex";

export default defineComponent({
  name: 'Banner',
  data() {
    return {
      banners: [],
      show: false,
      isDashboard: false,
    }
  },
  props: ['direction', 'position'],
  components: {
    IonSlides,
    IonSlide
  },
  methods: {
    ...mapActions('banners', ['getForState', 'getAll']),
    ...mapActions('googleanalytics', ['trackWithLabel']),
    trackBanner(banner) {
      console.log('Banner viewed:', banner)
      this.trackWithLabel('Banner viewed:' + banner);
    },
    async openLink(banner) {
      this.trackWithLabel('Banner viewed:' + banner.name);
      /*let external = await this.isExternalLink(banner.target_link)
      if (external) {
        window.open(banner.target_link, '_blank').focus();
      } else {
        console.log('banner', banner.target_link)
        router.push(banner.target_link[0]);
      }*/
    },
    getStyle(banner) {
      let url = 'https://fileserver.s3-de-central.profitbricks.com/' + banner.file.split('/')[4];
      return {
        'background-image': 'url(' + url || '' + ')',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover'
      }
    },

  },
  async created() {
    this.banners = await this.getForState({location: location.hash, position: this.position});
    //this.banners = await this.getAll();
    //console.log('banners', this.banners)
  },
  watch: {
    '$route': {
      // with immediate handler gets called on first mount aswell
      immediate: true,
      // handler will be called every time the route changes.
      // reset your local component state and fetch the new data you need here.
      async handler(to) {
        let from = localStorage.getItem('lastViewedRoute')
        this.banners = await this.getForState({location: to.href, position: this.position});
        //this.banners = await this.getAll();
        //console.log('banners', this.banners,to)
        if (this.position == 'fullscreen') {
          if (from == 'Dashboard') {
            this.isDashboard = true
          }
          let banner = this.banners.find(b => b.state.position == 'fullscreen');
          console.log('banner', banner)
          this.show = true;
          setTimeout(() => {
            this.show = false;
          }, banner && banner.state ? banner.state.duration * 1000 : 3000)
        }
      }
    }
  }
});
</script>
<style lang="scss" scoped>
#fullbanner {
  position: absolute;
  background-color: white !important;
  z-index: 1040; //999;
  width: 100%;
  height: 100%;

}

.banner-wrapper {
  height: 100px;
  color: #000;
  width: 100%;

  .swiper-no-swiping {
    img {
      padding: 5px;
    }
  }
}

@media (max-width: 768px) {
  .banner-wrapper {
    height: 80px;
    color: #000;
    width: 100%;

    .swiper-no-swiping {
      img {
        padding: 5px;
      }
    }
  }
}
</style>
